<template>
  <div>
    <el-table
        :data="campaigns.data"
        class="w100"
        stripe
        v-loading="loading"
    >
      <el-table-column label="Name" prop="name" sortable></el-table-column>
      <el-table-column label="Tag" prop="tag" sortable></el-table-column>
      <el-table-column label="Label Share">
        <template slot-scope="props">
          {{props.row.label_share}}%
        </template>
      </el-table-column>
      <el-table-column label="Platform Share">
        <template slot-scope="props">
          {{props.row.platform_share}}%
        </template>
      </el-table-column>
      <el-table-column label="Start Date" prop="start_date" sortable></el-table-column>
      
    </el-table>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'

export default {
  computed: {
    ...mapState('revShareCampaigns', ['campaigns', "loading"])
  },

  methods: {
    ...mapMutations('revShareCampaigns', ['setCampaignModal']),
    ...mapActions('revShareCampaigns', ['readCampaigns']),
  },

  created() {
    this.readCampaigns()
    this.setCampaignModal(false)
  }
}
</script>
]
